/**
 * Сервер отдаёт строку на плечо, а оператору нужен партнёр целиком: иначе одна
 * организация растягивается на четыре строки, и «включено» приходится читать
 * по каждой отдельно.
 *
 * Вынесено из компонента, чтобы правило проверялось тестом, не поднимая экран.
 */
export const groupByOrg = (list) => {
    const byOrg = new Map();

    // Ручка отдаёт правила всех субъектов: клиентские строки правятся в карточке
    // клиента, и на экране партнёров им делать нечего — org_id у них пуст, и
    // строка склеилась бы в несуществующую организацию.
    const partnerRows = (list ?? [])
        .filter((row) => (row.subjectType ?? "ORGANIZATION") === "ORGANIZATION");

    partnerRows.forEach((row) => {
        const org = byOrg.get(row.orgId) ?? {
            orgId: row.orgId,
            companyName: row.companyName,
            trustRequestPercent: false,
            active: false,
            miles: {},
        };
        org.companyName = org.companyName ?? row.companyName;
        // Признаки принадлежат организации: строки заводятся вместе, но
        // рассинхрон в базе возможен, и включённой считается включённая где угодно.
        org.trustRequestPercent = org.trustRequestPercent || Boolean(row.trustRequestPercent);
        org.active = org.active || Boolean(row.active);
        if (row.mileType) {
            org.miles[row.mileType] = { percent: row.percent ?? null, tariffPlanId: row.tariffPlanId ?? null };
        }
        byOrg.set(row.orgId, org);
    });

    return Array.from(byOrg.values())
        .sort((a, b) => (a.companyName ?? "").localeCompare(b.companyName ?? "", "ru"));
};
